import {
  CATEGORICAL_LEGEND_TYPE,
  type LegendType,
  RANGE_LEGEND_TYPE,
} from '../types/xy-chart-internals.js';

export function getLegendType(value: number | string): LegendType | undefined {
  if (Number.isNaN(value)) {
    return undefined;
  }

  return typeof value === 'number'
    ? RANGE_LEGEND_TYPE
    : CATEGORICAL_LEGEND_TYPE;
}
